module.exports = __webpack_public_path__ + "img/tensor_rank.08eb1048.png";